<div class="login-body">

  <div class="flex-row tw:h-screen" id="login">
    <div class="flex-column"></div>
    <div class="flex-column-main">

      <div class="content-wrapper">

        <app-login-brand></app-login-brand>

        <div class="login-card">
        <form name="form" (ngSubmit)="f.form.valid && login()" #f="ngForm" novalidate>
          <div [hidden]="showMfaTextField">
            <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !username.valid }">
              <input type="text" class="form-control" placeholder="Username" name="username" [(ngModel)]="model.username"
                #username="ngModel" required />
                @if (f.submitted && !username.valid) {
                  <div>Username is required</div>
                }
              </div>
              <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !password.valid }">
                <input type="password" class="form-control" placeholder="Password" name="password"
                  [(ngModel)]="model.password" #password="ngModel" required />
                  @if (f.submitted && !password.valid) {
                    <div>Password is required</div>
                  }
                </div>
                <div class="form-group">
                  <button class="btn-outline-light btn-lg login-submit" type="submit">Sign In</button>
                </div>
              </div>
              @if (showMfaTextField) {
                <div class="reg-flex-container">
                  <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
                    <div class="tw:flex-1 tw:px-[15px] tw:text-center">
                      <label class="mfa-header-label">Confirm your Identify</label><br/>
                      <label class="mfa-subtext-label">For added security, your Administrator has turned on additional security
                      verification to better secure your account.</label>
                      <label class="mfa-subtext-label">We've sent you a text message to your mobile device ending in
                      {{ mfaMobileLastDigits }}. <br /> Please enter the verification code in the box below to log in.</label>
                    </div>
                  </div>
                  <div class="flex-column" [ngClass]="{ 'has-error': f.submitted && !mfaCode.valid }">
                    <input placeholder="Authentication Code" class="form-control" name="mfaCode" type="text"
                      [(ngModel)]="model.mfaCode" #mfaCode="ngModel" required />
                      @if (f.submitted && !mfaCode.valid) {
                        <div>Authentication Code is required</div>
                      }
                    </div>
                    <div class="flex-column div-content-start">
                      <button class="btn-outline-light btn-lg" (click)="generateMfa('resend')">Resend</button>
                    </div>
                  </div>
                }
                <div class="form-group" [hidden]="!showMfaTextField">
                  <button class="btn-outline-light btn-lg login-submit" type="button" [disabled]="!f.form.valid" (click)="validateMfa()">Submit</button>
                </div>
                <div class="form-group" [hidden]="!showMfaTextField">
                  <button class="btn-outline-light btn-lg" (click)="showMfaTextField = false">Back to Login</button>
                </div>
                <div class="form-group" [hidden]="showMfaTextField">
                  <a [routerLink]="['/resetpassword']" class="btnwhite">Forgot Password?</a>
                </div>

                <div class="form-group or-line-container">
                  <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0">
                    <div class="tw:flex-1 tw:px-[15px] or-stripe"></div>
                    <div class="tw:px-[15px] tw:w-2/12 tw:sm:w-1/12 or-label">OR</div>
                    <div class="tw:flex-1 tw:px-[15px] tw:ml-6 or-stripe"></div>
                  </div>
                </div>

                <div class="form-group alternate-login-container">
                  <button class="btn-outline-light btn-lg tw:mb-6" type="button"
                  [routerLink]="['/student-login']">Learner Login</button>
                </div>

                <div class="form-group">
                  <button class="btn-outline-light btn-lg" type="button"
                  (click)="segAccessLogin()">Supporting Education Group Access</button>
                  <label class="tw:block tw:mt-2 tw:text-sm">
                    <input type="checkbox" [(ngModel)]="challengeAccount" name="challengeAccount" />
                    Sign in as a different account
                  </label>
                </div>

              </form>
              </div>

            </div>

          </div>
          <div class="flex-column"></div>
        </div>
      </div>